/* =============================================================
   TRESTLETHORN — Custom JS for Dawn 15.4.1
   Drop into: assets/trestlethorn-theme.js
   Then add to layout/theme.liquid before </body>:
     <script src="{{ 'trestlethorn-theme.js' | asset_url }}" defer></script>
   ============================================================= */

(function () {
  'use strict';

  /* ──────────────────────────────────────────
     1. STICKY SHRINKING HEADER
     Adds .scrolled class to .header-wrapper
     when page scrolls past 80px
  ────────────────────────────────────────── */
  function initStickyHeader() {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    const SCROLL_THRESHOLD = 80;
    let ticking = false;

    function updateHeader() {
      if (window.scrollY > SCROLL_THRESHOLD) {
        headerWrapper.classList.add('scrolled');
      } else {
        headerWrapper.classList.remove('scrolled');
      }
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }


  /* ──────────────────────────────────────────
     2. PRODUCT CARD — Hover Image Swap
     Swaps to the 2nd product image on hover.
     Dawn renders images in <img> tags with
     data-srcset. We clone the src and swap.
  ────────────────────────────────────────── */
  function initHoverImageSwap() {
    const cards = document.querySelectorAll('.card-wrapper');

    cards.forEach(card => {
      const mediaEl = card.querySelector('.card__media');
      if (!mediaEl) return;

      const images = mediaEl.querySelectorAll('img');
      if (images.length < 2) return;

      const primaryImg   = images[0];
      const secondaryImg = images[1];

      // Style the secondary image to sit on top, hidden
      Object.assign(secondaryImg.style, {
        position:   'absolute',
        inset:      '0',
        width:      '100%',
        height:     '100%',
        objectFit:  'cover',
        opacity:    '0',
        transition: 'opacity 0.35s ease',
        zIndex:     '2',
      });

      // Ensure primary img fills the container
      Object.assign(primaryImg.style, {
        transition: 'opacity 0.35s ease',
      });

      card.addEventListener('mouseenter', () => {
        secondaryImg.style.opacity = '1';
        primaryImg.style.opacity   = '0';
      });

      card.addEventListener('mouseleave', () => {
        secondaryImg.style.opacity = '0';
        primaryImg.style.opacity   = '1';
      });
    });
  }


  /* ──────────────────────────────────────────
     3. STICKY ADD-TO-CART BAR (Product Page)
     Appears when the main ATC button scrolls
     out of the viewport.
  ────────────────────────────────────────── */
  function initStickyAtcBar() {
    // Only run on product pages
    const mainAtc = document.querySelector('.product-form__submit');
    if (!mainAtc) return;

    // Get product info for the bar — strip CWR SKU codes like [45-741-BL]
    const SKU_PATTERN = /\s*\[[^\]]{2,20}\]\s*$/;
    const productTitle = (document.querySelector('.product__title')?.textContent?.trim() || '').replace(SKU_PATTERN, '').trim();
    const productPrice = document.querySelector('.product .price__regular .price-item')?.textContent?.trim() || '';

    // Build the bar
    const bar = document.createElement('div');
    bar.className = 'tt-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = `
      <div class="tt-sticky-atc__info">
        <span class="tt-sticky-atc__title">${productTitle}</span>
        <span class="tt-sticky-atc__price">${productPrice}</span>
      </div>
      <button class="tt-sticky-atc__btn" type="button" aria-label="Add to cart">
        Add to Cart
      </button>
    `;
    document.body.appendChild(bar);

    // Wire the sticky button to submit the real form
    bar.querySelector('.tt-sticky-atc__btn').addEventListener('click', () => {
      mainAtc.click();
    });

    // Show/hide based on ATC visibility
    let ticking = false;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          bar.classList.remove('visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          bar.classList.add('visible');
          bar.setAttribute('aria-hidden', 'false');
        }
      },
      { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
    );

    observer.observe(mainAtc);
  }


  /* ──────────────────────────────────────────
     4. QUICK-ADD ACCESSIBILITY ENHANCEMENT
     Dawn's quick-add already works, but we
     ensure keyboard focus is handled correctly
     on the cards we've styled.
  ────────────────────────────────────────── */
  function initQuickAddKeyboard() {
    document.querySelectorAll('.card-wrapper').forEach(card => {
      card.addEventListener('focusin', () => {
        card.classList.add('card-wrapper--focused');
      });
      card.addEventListener('focusout', () => {
        card.classList.remove('card-wrapper--focused');
      });
    });
  }


  /* ──────────────────────────────────────────
     5. SMOOTH SCROLL for anchor links
  ────────────────────────────────────────── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', e => {
        const target = document.querySelector(anchor.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }


  /* ──────────────────────────────────────────
     6. ROTATING ANNOUNCEMENT BAR
     Cycles through trust messages with a
     fade transition every 4.5 seconds.
  ────────────────────────────────────────── */
  function initRotatingAnnouncementBar() {
    var wrapper = document.querySelector('.announcement-bar__message');
    if (!wrapper) return;

    var messages = [
      '$9.95 FLAT RATE SHIPPING &nbsp;·&nbsp; EXCLUDES OVERSIZED ITEMS',
      'FREE RETURNS &nbsp;·&nbsp; 30-DAY RETURN POLICY',
      'FEATURING &nbsp;·&nbsp; GARMIN &nbsp;·&nbsp; HUMMINBIRD &nbsp;·&nbsp; MINN KOTA',
      'FAST SHIPPING FROM US WAREHOUSES'
    ];

    var idx = 0;
    wrapper.style.transition = 'opacity 0.4s ease';

    setInterval(function () {
      wrapper.style.opacity = '0';
      setTimeout(function () {
        idx = (idx + 1) % messages.length;
        wrapper.innerHTML = '<p class="announcement-bar__message-link">' + messages[idx] + '</p>';
        wrapper.style.opacity = '1';
      }, 420);
    }, 4500);
  }


  /* ──────────────────────────────────────────
     7. MEGA MENU LIFESTYLE IMAGE PANEL
     Injects a lifestyle photo on the right side
     of every mega menu dropdown (desktop only).
     → Upload a photo to Shopify Admin → Content → Files
     → Copy its CDN URL and paste it into IMAGE_URL below
  ────────────────────────────────────────── */
  function initMegaMenuImages() {
    if (window.innerWidth < 990) return;

    // Paste your Shopify CDN image URL here, e.g.:
    // 'https://cdn.shopify.com/s/files/1/0598/9c4c/files/trestlethorn-hero.jpg'
    var IMAGE_URL = '';
    if (!IMAGE_URL) return;

    document.querySelectorAll('.mega-menu__list').forEach(function (list) {
      var parent = list.parentElement;
      if (!parent || parent.classList.contains('tt-has-mega-img')) return;

      parent.classList.add('tt-has-mega-img');

      var panel = document.createElement('div');
      panel.className = 'tt-mega-img';
      panel.setAttribute('aria-hidden', 'true');
      panel.innerHTML = '<img src="' + IMAGE_URL + '" alt="" loading="lazy">';
      parent.appendChild(panel);
    });
  }


  /* ──────────────────────────────────────────
     INIT — Run after DOM is ready
  ────────────────────────────────────────── */
  function init() {
    initStickyHeader();
    initHoverImageSwap();
    initStickyAtcBar();
    initQuickAddKeyboard();
    initSmoothScroll();
    initRotatingAnnouncementBar();
    initMegaMenuImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ──────────────────────────────────────────
     Re-run image swap after Shopify section
     renders (handles theme editor previews)
  ────────────────────────────────────────── */
  document.addEventListener('shopify:section:load', initHoverImageSwap);

})();
